module.exports = __webpack_public_path__ + "static/media/children_2x.312dff95.png";